export default function CTASection() {
  return (
    <section className="w-full bg-background-100/60 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="relative rounded-lg overflow-hidden border border-background-200/80">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20moody%20abstract%20banner%20of%20scattered%20paper%20fragments%20and%20glowing%20amber%20threads%20connecting%20them%20on%20a%20dark%20near%20black%20surface%2C%20stylized%20editorial%20texture%2C%20cinematic%20warm%20side%20light%2C%20high%20detail%2C%20deep%20terracotta%20and%20gold%20tones%2C%20no%20people&width=1600&height=520&seq=llhl-cta-01&orientation=landscape"
            alt="灵灵黑料完整版归档计划背景图"
            title="灵灵黑料 未删内容 归档"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/45" />
          <div className="relative z-10 px-6 py-12 md:px-12 md:py-16 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h3 className="font-heading font-black text-background-50 text-2xl md:text-4xl leading-snug">
                你手里也有没被删干净的截图？
              </h3>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/80">
                把时间、平台和内容描述留下，我们会在核对后补进灵灵黑料未删内容的存档里，
                并标注来源编号，方便后来的人自己对照。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="#comments"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-upload-2-line" />
                提交线索
              </a>
              <a
                href="#screenshots"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/35 text-background-50 text-sm font-label hover:bg-background-50/10 transition-colors whitespace-nowrap"
              >
                <i className="ri-gallery-view-2" />
                看现有存档
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}